import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const GetStockTrackerProducts = createModule({
    base: 'GET_STOCK_TRACKER_PRODUCTS',
    apiDetails: { ...SERVICE_ENDPOINT.STOCK_TRACKER, method: 'get' },
    errors: { defaultError: true, customError: '' },
    enableNotification: true,
});

export { GetStockTrackerProducts };
